import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { INSTAGRAM_URL, WHATSAPP_URL } from "../data/content";
import { Logo } from "./Navbar";
import { WhatsAppIcon } from "./WhatsAppFab";

const LEGAL = [
  { label: "Aviso legal", to: "/aviso-legal" },
  { label: "Política de privacidad", to: "/privacidad" },
  { label: "Política de cookies", to: "/cookies" },
  { label: "Términos y condiciones", to: "/terminos-y-condiciones" },
];

const Footer = () => (
  <footer data-testid="rnb-footer" className="border-t border-zinc-900 bg-[#050505]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
        <div className="space-y-4">
          <Logo />
          <p className="text-sm text-zinc-500 max-w-xs leading-relaxed">
            Tu mejor físico, de forma natural. Entrenamiento y nutrición online con Dani Postigo.
          </p>
          <div className="flex items-center gap-4 pt-1">
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="rnb-footer-instagram"
              aria-label="Instagram @dpostigo91"
              className="h-10 w-10 border border-zinc-800 flex items-center justify-center text-zinc-400 hover:text-black hover:bg-white hover:border-white transition-colors"
            >
              <Instagram className="h-4 w-4" />
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="rnb-footer-whatsapp"
              aria-label="WhatsApp"
              className="h-10 w-10 border border-zinc-800 flex items-center justify-center text-zinc-400 hover:text-black hover:bg-white hover:border-white transition-colors"
            >
              <WhatsAppIcon className="h-4 w-4" />
            </a>
          </div>
        </div>
        <nav className="grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-3" aria-label="Legal">
          {LEGAL.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`rnb-footer-link-${l.to.slice(1)}`}
              className="text-xs tracking-[0.15em] uppercase text-zinc-500 hover:text-white transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
      <div className="mt-12 pt-6 border-t border-zinc-900 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="text-xs text-zinc-600">© 2026 Real Natural Bodybuilding LLC. Todos los derechos reservados.</p>
        <p className="text-[10px] tracking-[0.3em] text-zinc-700 uppercase">100% Natural · Sin atajos</p>
      </div>
    </div>
  </footer>
);

export default Footer;
